var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportChatChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30.9 30.9",
    style: {
      enableBackground: "new 0 0 30.9 30.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,11.3C0,5,5.3-0.1,11.6,0c6.2,0.1,11.2,5.2,11.2,11.4c0,6.3-4.9,11.3-11.2,11.4c-1.8,0-3.5-0.3-5.1-1.1 c-0.4-0.2-0.9-0.1-1.2,0.2C4,23.1,2.2,23.5,0.5,23c1.1-2.2,1.2-4.7,0.4-7.1c0,0,0,0,0-0.1C0.3,14.4,0,12.9,0,11.3z M3.7,11.4 c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6C4.4,9.8,3.7,10.5,3.7,11.4z M9.7,11.4c0,0.9,0.7,1.6,1.6,1.6 c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6C10.5,9.8,9.7,10.5,9.7,11.4z M15.8,11.4c0,0.9,0.7,1.6,1.6,1.6 c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6C16.6,9.8,15.8,10.5,15.8,11.4z M25.6,29.5c-0.2-0.2-0.5-0.3-0.7-0.3 c-0.2,0-0.3,0-0.4,0.1c-1.6,0.8-3.3,1.1-5.1,1.1c-4.1-0.1-7.8-2.3-9.7-5.7c0.7,0.1,1.3,0.1,2,0.1c3.6-0.1,6.9-1.5,9.4-4 c2.5-2.5,3.9-5.9,3.9-9.5c0-0.8-0.1-1.7-0.2-2.5c2.5,1.2,4.5,3.4,5.5,5.9c1.2,2.9,0.9,5.9-0.1,8.8c-0.8,2.3-0.7,4.9,0.4,7.1 C28.7,31.2,26.9,30.8,25.6,29.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportChatChat);
export default __webpack_public_path__ + "static/media/supportChatChat.fe15f19bfa397b628eea48a8ada4d000.svg";
export { ForwardRef as ReactComponent };